import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule, AbstractControl, ValidationErrors, } from "@angular/forms";
import { Router } from "@angular/router";
import { VendorService } from 'src/app/services/vendor.service';

import { AdminProfileDataService } from "src/app/admin-profile-data.service";
import { passwordMatcher } from "src/app/pages/confirmpassword";
import { AdminService } from "src/app/services/admin.service";
import { AuthService } from "src/app/services/auth.service";
import { UtilsService } from "src/app/utils.service";
import { SnackBarService } from 'src/app/shared/services/snack-bar.service';
import { HeaderLatestComponent } from 'src/app/home/landing-root/header-latest/header-latest.component';
import { FooterMoreInfoComponent } from 'src/app/home/landing-root/footer-more-info/footer-more-info.component';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { OurAppsComponent } from 'src/app/home/about-root/our-apps/our-apps.component';
import { ValidationService } from 'src/app/shared/services/validation.service';

@Component({
  selector: 'app-vendor-forgot-password',
  standalone: true,
  imports: [
    HeaderLatestComponent,
    FooterMoreInfoComponent,
    OurAppsComponent,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './vendor-forgot-password.component.html',
  styleUrls: ['./vendor-forgot-password.component.scss']
})
export class VendorForgotPasswordComponent {
  form: FormGroup;
  forgetEmail : any;
  validForgetEmail: boolean=false;

  constructor(
    private fb: FormBuilder,
    private vendorService: VendorService,
    private router: Router,
    private utilsService: UtilsService,
    private authService: AuthService,
    private adminProfileDataService: AdminProfileDataService,
    private snackbarService: SnackBarService,
    private validationService: ValidationService

  ) {
    this.form = this.fb.group({
    email_or_mobile: ['', [this.validationService.emailOrMobileValidator.bind(this.validationService)]]
      
    });
     // Auto-append +91 if input is 10-digit mobile number
 /*  this.adminLoginForm.get('email_or_mobile')?.valueChanges.subscribe((value: string) => {
    if (!value) return;

    const trimmed = value.trim();
    const isMobile = /^\d{10}$/.test(trimmed);
    const hasPrefix = trimmed.startsWith('+91');

    if (isMobile && !hasPrefix) {
      this.adminLoginForm.get('email_or_mobile')?.patchValue(`+91${trimmed}`, { emitEvent: false });
    }
  }); */
  }


  onSubmit() {
    if (this.form.valid) {
      console.log("Form submitted successfully!", this.form.value);
      this.forgotPassword();
    }
    this.forgetEmail = this.form.value.email_or_mobile;
    
  }

  goTo(link: any) {
    this.router.navigate([link]); 
  }

  forgotPassword() {
    let reqObj = {
      // email: this.adminLoginForm.value["email"],
      // mobile: this.adminLoginForm.value["mobile"],
      email_or_mobile: this.form.value["email_or_mobile"],
    };
    console.log("Form", this.form.value);
    console.log("reqObj", reqObj);
    // return;

    this.vendorService.forgotPassword(reqObj).subscribe((resp: any) => {
      console.log("Rec profile update success", resp);

      if (resp.statusCode == 200) {
        this.validForgetEmail=true;
        this.form.reset();
        this.snackbarService.open(resp.supportMessage, 'close', 5000, "center", "top")
        // this.router.navigate(["/login"]);
      }
    });
  }

isMobile(value: string): boolean {
  const mobile = value.replace('+91', '');
  return /^[0-9]{10}$/.test(mobile);
}



}
